import {
  PLATFORM_AGILE_ROLES,
  PLATFORM_SUPER_ADMIN,
} from "@/types/userV2Permissions";
import { useUserMeV2 } from "./useUsersV2";
import { APPLICATION_NAMES, UserV2, UseUserMeV2Info } from "@/types";
import {
  isAbleToActOnUser,
  isAbleToActivateUser,
} from "@/lib/utils/userV2ContextUtils";
import { TAG_TYPE_NAME } from "@/types/tagsV2";

const EMPTY_USER: UseUserMeV2Info = {
  user: null,
  canViewOnlyAgileProjects: false,
  isPlatformSuperAdmin: false,
  isAbleToActOnUser: () => false,
  isAbleToActivateUser: () => false,
  isRegionalLead: false,
  isAdvancedFlexpertSupport: false,
  isAgileAdmin: false,
  currentUserAgileRegions: [
    {
      label: "",
      value: 0,
    },
  ],
};

export const useUserMeV2Info = (): UseUserMeV2Info => {
  const { user } = useUserMeV2();

  if (!user) {
    return EMPTY_USER;
  }

  const currentUserRoles = user.role_associations.map((role) => role.code);

  const currentUserAgileRole = user.role_associations.find(
    (role) => role.application === APPLICATION_NAMES.PLATFORM
  );

  const currentUserAgileRegions = currentUserAgileRole?.tags
    .filter((tag) => tag.tag_type === TAG_TYPE_NAME.REGION)
    .map((tag) => {
      return {
        label: tag.name,
        value: tag.id,
      };
    });

  const isPlatformSuperAdmin = currentUserRoles.some(
    (role) => role === PLATFORM_SUPER_ADMIN
  );

  const isAgileAdmin = currentUserRoles.some(
    (role) => role === PLATFORM_AGILE_ROLES.AGILE_ADMIN
  );

  const isRegionalLead = currentUserRoles.some(
    (role) => role === PLATFORM_AGILE_ROLES.AGILE_REGIONAL_LEAD
  );

  const isAdvancedFlexpertSupport = currentUserRoles.some(
    (role) => role === PLATFORM_AGILE_ROLES.AGILE_ADVANCED_FLEXPERT_SUPPORT
  );

  return {
    isPlatformSuperAdmin,
    canViewOnlyAgileProjects: !isPlatformSuperAdmin,
    isAbleToActOnUser: (targetUser: UserV2) =>
      isAbleToActOnUser(
        targetUser,
        user,
        isPlatformSuperAdmin,
        currentUserAgileRegions
      ),
    isAbleToActivateUser: (targetUser: UserV2) =>
      isAbleToActivateUser(targetUser, user),
    isAgileAdmin,
    currentUserAgileRegions,
    isRegionalLead,
    isAdvancedFlexpertSupport,
    user,
  };
};
